export default function formatAndRoundPercentage(feesPercent) {
  if (Number.isNaN(parseFloat(feesPercent))) {
    return feesPercent;
  }

  return `${parseFloat(feesPercent).toFixed(2)}%`;
}
